<template>
  <Transition name="manage-custom-fields-overlay">
    <div
      v-if="visible"
      class="manage-custom-fields-modal-overlay manage-custom-fields-modal-overlay--glass"
      @click.self="close"
    >
      <Transition name="manage-custom-fields-panel" appear>
        <div
          v-if="visible"
          class="manage-custom-fields-modal-container manage-custom-fields-modal-container--glass"
          role="dialog"
          aria-labelledby="manage-custom-fields-title"
          @click.stop
        >
          <div class="manage-custom-fields-modal-header manage-custom-fields-modal-header--glass">
            <h2 id="manage-custom-fields-title" class="manage-custom-fields-modal-title">
              <i class="bi bi-sliders2 manage-custom-fields-modal-title__icon" aria-hidden="true"></i>
              Manage Custom Fields
            </h2>
            <button
              type="button"
              class="manage-custom-fields-close-btn"
              aria-label="Close"
              title="Close"
              @click="close"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>

          <div class="manage-custom-fields-modal-content manage-custom-fields-modal-content--glass">
            <PrimaryButton
              label="Add Field"
              icon="bi bi-plus-lg"
              custom-class="manage-custom-fields-add-btn"
              @click="addField"
            />

            <div class="manage-custom-fields-table-section consultant-glass-table-section">
              <div class="consultant-glass-table-responsive consultant-glass-table-responsive--framed">
                <div class="consultant-glass-table-scroll-x">
                  <table class="consultant-glass-table manage-custom-fields-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Client</th>
                        <th>Vendor</th>
                        <th>Employee</th>
                        <th class="manage-custom-fields-table__actions-col" aria-label="Actions"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="fields.length === 0">
                        <td colspan="5" class="consultant-glass-table-no-records">
                          No custom fields. Click Add Field to create one.
                        </td>
                      </tr>
                      <tr
                        v-for="(field, idx) in fields"
                        :key="'field-' + idx"
                        class="consultant-glass-table-row manage-custom-fields-table-row"
                        :class="`manage-custom-fields-table-row--${idx + 1}`"
                      >
                        <td>
                          <input
                            v-model="field.name"
                            type="text"
                            placeholder="Field Name"
                            class="manage-custom-fields-field-input"
                          />
                        </td>
                        <td>
                          <GlassToggle
                            :input-id="`custom-field-${idx}-client`"
                            v-model="field.client"
                            aria-label="Client"
                          />
                        </td>
                        <td>
                          <GlassToggle
                            :input-id="`custom-field-${idx}-vendor`"
                            v-model="field.vendor"
                            aria-label="Vendor"
                          />
                        </td>
                        <td>
                          <GlassToggle
                            :input-id="`custom-field-${idx}-employee`"
                            v-model="field.employee"
                            aria-label="Employee"
                          />
                        </td>
                        <td class="manage-custom-fields-table__actions-col">
                          <button
                            type="button"
                            class="manage-custom-fields-delete-btn"
                            aria-label="Delete field"
                            title="Delete field"
                            @click="removeField(idx)"
                          >
                            <i class="bi bi-trash3" aria-hidden="true"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="manage-custom-fields-modal-actions manage-custom-fields-modal-actions--glass">
            <SecondaryButton label="Cancel" icon="bi bi-x-lg" @click="close" />
            <PrimaryButton label="Save" icon="bi bi-check-lg" @click="saveFields" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script>
import './ManageCustomFields.css';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';
import GlassToggle from '@/components/GlassToggle.vue';

export default {
  name: 'ManageCustomFields',
  components: { PrimaryButton, SecondaryButton, GlassToggle },
  emits: ['close'],
  data() {
    return {
      visible: true,
      fields: [{ name: '', client: false, vendor: false, employee: false }],
    };
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close');
    },
    addField() {
      this.fields.push({ name: '', client: false, vendor: false, employee: false });
    },
    removeField(idx) {
      this.fields.splice(idx, 1);
    },
    saveFields() {
      this.visible = false;
      this.$emit('close');
    },
  },
};
</script>
